export const messages = {
  en: {
    deleteApplyWithholdIntegral: {
      title: 'Delete Withhold Integral Application',
      confirm: 'Are you sure to delete this withhold integral application?',
      deleteSuccess: 'Withhold integral application deleted successfully',
      deleteFailed: 'Failed to delete withhold integral application',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete'
    }
  },
  zh: {
    deleteApplyWithholdIntegral: {
      title: '删除扣分申请',
      confirm: '确定要删除这个扣分申请吗？',
      deleteSuccess: '扣分申请删除成功',
      deleteFailed: '扣分申请删除失败',
      cancel: '取消',
      confirmDelete: '确认删除'
    }
  }
} 